
export enum ApiTypeCategoryCd {
	CUSTOM = 'Custom',
	ENUM = 'Enum',
	GENERATED = 'Generated',
	PRIMITIVE = 'Primitive'}

